document.addEventListener('DOMContentLoaded', function() {
    var checkWidget = setInterval(function() {
      if (document.querySelector('.rc-container')) {
        clearInterval(checkWidget);
  
        // Target the one-time option
        const oneTimeOption = document.querySelector('.rc-option__onetime');
        if (!oneTimeOption) return;
  
        // Create custom dialog HTML matching the image
        const customDialog = document.createElement('div');
        customDialog.className = 'custom-one-time-dialog';
        customDialog.innerHTML = `
          <h4>CHOOSE AN OPTION</h4>
          <div class="custom-option">
            <label>
              <input type="radio" name="pack" value="single" checked data-quantity="1">
              Single Pack
            </label>
            <span class="custom-price">$39.95</span>
          </div>
          <div class="custom-option">
            <label>
              <input type="radio" name="pack" value="double" data-quantity="2">
              Double Pack (Save 5%)
            </label>
            <span class="custom-price">
              <span class="custom-original-price">$79.90</span> $78.30
            </span>
          </div>
          <div class="custom-option">
            <label>
              <input type="radio" name="pack" value="triple" data-quantity="3">
              Triple Pack (Save 8%!)
            </label>
            <span class="custom-price">
              <span class="custom-original-price">$119.85</span> $113.86
            </span>
          </div>
        `;
  
        // Append dialog to one-time option
        oneTimeOption.parentElement.appendChild(customDialog);
  
        // Show dialog when one-time is selected
        const oneTimeRadio = document.querySelector('.rc-radio__input[for*="onetime"]'); // Adjust selector if needed
        oneTimeRadio.addEventListener('change', function() {
          if (this.checked) {
            customDialog.classList.add('active');
          } else {
            customDialog.classList.remove('active');
          }
        });
  
        // Handle add-to-cart override (intercept form submit)
        const productForm = document.querySelector('form[action="/cart/add"]');
        if (productForm) {
          productForm.addEventListener('submit', function(e) {
            if (oneTimeRadio.checked) {
              e.preventDefault();
              const selectedPack = customDialog.querySelector('input[name="pack"]:checked');
              if (selectedPack) {
                const quantity = selectedPack.dataset.quantity;
                const variantId = productForm.querySelector('[name="id"]').value; // Current variant ID
  
                // Add to cart via AJAX with adjusted quantity
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: variantId, quantity: quantity })
                })
                .then(response => response.json())
                .then(data => {
                  // Optional: Update cart UI or redirect to cart
                  window.location.href = '/cart';
                })
                .catch(error => console.error('Error adding to cart:', error));
              }
            }
          });
        }
      }
    }, 100); // Check every 100ms
  });